// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","innerContainer":"Footer_innerContainer__25ozp","navLinks":"Footer_navLinks__2bcZx","footerLink":"Footer_footerLink__38Wi9"};